import { Link } from "react-router-dom";
import { formatViews, getHotMovies } from "@/lib/movieData";

export default function HotSection() {
  const hot = getHotMovies(8);

  return (
    <section className="bg-background-50 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1180px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-7">
            <div>
              <p className="text-[11px] tracking-[0.3em] text-foreground-400 uppercase">Popular</p>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">热门推荐</h2>
              <p className="mt-2 text-sm text-foreground-600">根据站内浏览量实时排序，看看大家最近在关注什么</p>
            </div>
            <Link
              to="/search?q=悬疑"
              className="inline-flex items-center gap-1.5 text-sm text-foreground-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              更多热门内容
              <i className="ri-fire-line text-base"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 lg:gap-x-12">
            {hot.map((movie, index) => (
              <Link
                key={movie.id}
                to={`/detail/${movie.id}`}
                className="group flex items-start gap-4 py-5 border-b border-background-200 cursor-pointer"
              >
                <span className="w-9 shrink-0 font-heading text-2xl md:text-3xl leading-none text-background-400 group-hover:text-accent-400 transition-colors text-center">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="w-[68px] h-[96px] rounded-md overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={movie.poster}
                    alt={`《${movie.title}》海报，${movie.year}年上映`}
                    title={`${movie.title} - 秋霞电影`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="font-heading text-base text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                      {movie.title}
                    </h3>
                    <span className="shrink-0 inline-flex items-center gap-1 text-xs text-accent-700">
                      <i className="ri-eye-line"></i>
                      {formatViews(movie.views)}
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs text-foreground-500">
                    {movie.types.join(" / ")} · {movie.year} · {movie.region}
                  </p>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2">
                    {movie.summary}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}